import {
  useBookingsCreatingStore,
  useBookingsEditingStore,
  usePlannerStore,
  useSelectedProjectStore,
} from "../../../../../stores/planner";
import { shallow } from "zustand/shallow";
import { useEffect } from "react";
import Api from "../../../../../Api";
import { DateTime } from "luxon";
import PropTypes from "prop-types";

const BookingPrecheck = ({ popupMode, users }) => {
  const [precheckResult, setPrecheckResult] = usePlannerStore(
    (state) => [state.precheckResult, state.setPrecheckResult],
    shallow
  );
  const [bookingsCreating] = useBookingsCreatingStore((state) => [state.bookingsCreating], shallow);
  const [editingBookings] = useBookingsEditingStore((state) => [state.bookingsEditing], shallow);

  useEffect(() => {
    const finalBookings = popupMode === "creating" ? creationBookings() : editingBookings;
    const bookingsWithProject = finalBookings.map((b) => ({
      ...b,
      project_id: useSelectedProjectStore.getState().selectedProject?.id,
    }));

    Api.Bookings.precheck_bookings(bookingsWithProject).then((res) => {
      setPrecheckResult(res.data);
    });
  }, [useSelectedProjectStore.getState().selectedProject, bookingsCreating.length, editingBookings.length]);

  const creationBookings = () =>
    bookingsCreating.map((b) => ({ user_id: users[b[0]]?.id, date: DateTime.fromJSDate(b[1]).toISODate(), id: 0 }));

  const precheckText = () => {
    const results = precheckResult.status === "error" ? precheckResult.errors : precheckResult.warnings;

    return <p className="precheck-text">{results[0]}</p>;
  };

  if (precheckResult.status === "ok") {
    return <></>;
  }

  return <div className="precheck-result">{precheckText()}</div>;
};

BookingPrecheck.propTypes = {
  popupMode: PropTypes.string.isRequired,
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default BookingPrecheck;
